type Employee = {
  email?: string | null | undefined;
  is_eligible: boolean;
  override_employee_type: boolean;
  hash_id: string;
  employee_type: string;
  si_managed: boolean;
};

export const canEdit = (employee: Employee) => employee.si_managed;
export const cannotEdit = (employee: Employee) => !canEdit(employee);
